<template>


  <!-- Create By Joker Banny -->
  <div
      class="bg-white rounded-lg py-2 shadow-lg hover:shadow-2xl transition duration-500 transform hover:scale-105 cursor-pointer">
    <div class="flex mb-2 ">
      <div class="px-2"><h1 class="mb-1 text-xl font-bold text-gray-700">{{ card.id }}</h1>
        <p class="text-sm font-normal text-gray-400 mr-14 hover:underline">{{ card.updated_at }}</p></div>
    </div>
    <div class="px-2">
      <div v-for="answer in card.answers" class="mb-2">
        <div class="font-bold text-black break-words">{{ answer.question }}</div>
        <div class="font-bold text-gray-400 break-words">{{ answer.answer }}</div>
      </div>
    </div>

  </div>

</template>

<script>

import {defineComponent, ref} from "vue";

export default defineComponent({
  props: [
    'card'
  ],
  emits: [],
  components: {},
  methods: {},
  setup() {

    return {
    }
  },
});
</script>
